
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import Config from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false) // 是否在app内
        const templateConfig = $store.state.activityData.templateConfig
        const list = ref<any[]>([])

        const getData = () => {
            _this.proxy.$request('/vote', {
                aid: $store.state.aid,
                sort: 'info.no'
            }).then((data: any) => {
                // 设置分享信息
                if (data && data.list && data.list.length) {
                    data.list.forEach((val) => {
                        if (!val.info) return
                        const index = list.value.findIndex((item) => val.info.type === item.type)
                        if (index > -1) {
                            list.value[index].goods.push(Object.assign({}, val.info))
                        } else {
                            list.value.push({
                                img: val.info.typeImg || '',
                                type: val.info.type,
                                goods: [
                                    val.info
                                ]
                            })
                        }
                    })
                } 
            })
        }

        const downLoad = () => {
            $store.commit('SET_DIALOGDATA', {
                text: '参加该活动需在封面新闻APP中进行',
                btns: [
                    {
                        text: '取消'
                    },
                    {
                        text: '确定',
                        className : 'download-btn'
                    }
                ]
            })
        }

        const goGoods = (item) => {
            if (!item.goodsId && !item.link) return
            if (!isApp.value && !templateConfig.isCanView) {
                downLoad()
                return
            }
            const link = item.link || `${Config.WAP_URL}/jifen_goods.html?productId=${item.goodsId}`
            if (item.goodsId) {
                COVER.track('click', `去积分商品详情页-商品id：${item.goodsId}`)
            } else {
                COVER.track('click', `去外链：${item.link}`)
            }
            setTimeout(() => {
                window.location.href = link
            }, 300)
        }

        const goTopic = (id) => {
            COVER.track('click', '跳转到青椒话题')
            if (!isApp.value) {
                downLoad()
                return
            }
            setTimeout(() => {
                if (isApp.value) {
                    window.location.href = `cover://cn.thecover.www/news?id=${id}&flag=100`
                } else {
                    window.location.href = `${Config.WAP_URL}/topic.html?topic_id=${id}`
                }
            }, 300)
        }

        getData()

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            COVER.track('load', $store.state.activityData.title)
            setTimeout(() => {
                COVER.pageLoaded()
            }, 300)
            COVER.onshare($store.state.shareData)
        })    

        return {
            templateConfig,
            list,
            goGoods,
            goTopic
        }
    }
})
